function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9332 6.66719C13.8895 6.56209 13.8282 6.46575 13.7407 6.38692L7.61426 0.256176C7.27293 -0.0853938 6.72156 -0.0853937 6.38023 0.256177C6.0389 0.597747 6.0389 1.14951 6.38023 1.49108L11.01 6.12418L0.875203 6.12418C0.393842 6.12418 1.1397e-06 6.5183 1.22392e-06 7C1.30814e-06 7.4817 0.393842 7.87582 0.875204 7.87582L11.0188 7.87582L6.38898 12.5089C6.04765 12.8505 6.04765 13.4023 6.38898 13.7438C6.73031 14.0854 7.28169 14.0854 7.62301 13.7438L13.7494 7.61307C13.8282 7.53425 13.8895 7.43791 13.942 7.33281C14.0207 7.12261 14.0207 6.87738 13.9332 6.66719Z",
  fill: "current"
});

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.65fe4ebb.svg";
export { ForwardRef as ReactComponent };